import React from 'react';
import appSyncConfig from '../AppSync';

class Ads extends React.Component {
	constructor(props) {
		super(props);
	}

  	render() {
        const { adv, i } = this.props;
        let isExternalAds = adv.type === '2' ? true : false;
        return (
            <div className={`carousel-item ads-${adv.size} ${(i === 0) ? 'active' : ''}`} key={i}>
                {isExternalAds ? (
                    <span dangerouslySetInnerHTML={{__html: adv.description}}></span>
                ) : (
                    <a href={adv.link} target={adv.target}><img className="d-block img-fluid" src={`${appSyncConfig.s3_url}${adv.image}`} alt={adv.image} /></a>
                )}
            </div>
        );
    }
}

export default Ads;
    